import { Menu } from "antd";

import MetricsIcon from "@/assets/icons/graph.svg?react";

import type { PortfolioMetricPanel } from "./portfolioMetricPanels.types";

const CARD_CLASS =
  "rounded-lg border border-black/[0.04] bg-white shadow-[0_2px_15px_4px_rgba(0,0,0,0.02)]";

export function PortfolioMetricsRail({
  panels,
  activeKey,
  onSelect,
  trialCount,
}: {
  panels: PortfolioMetricPanel[];
  activeKey: string;
  onSelect: (key: string) => void;
  trialCount: number;
}) {
  return (
    <div className="flex w-[244px] min-w-[244px] flex-col gap-2.5">
      <div className={`${CARD_CLASS} flex flex-col gap-1 px-3.5 py-3`}>
        <div className="mb-1 flex items-center gap-2">
          <div className="flex items-center rounded-[4px] bg-brand-dark p-[5px] text-white">
            <MetricsIcon width={18} height={18} />
          </div>
          <span className="text-[10px] font-semibold uppercase tracking-wide text-editor-icon">
            Metrics
          </span>
        </div>
        <span className="text-[14px] font-semibold leading-tight text-[#1F2933]">
          Portfolio performance
        </span>
        <span className="text-[12px] text-[#8C8C8C]">
          {trialCount === 1
            ? "1 trial in view"
            : `${trialCount} trials in view`}
        </span>
      </div>

      <div className={`${CARD_CLASS} overflow-clip overflow-y-auto`}>
        <Menu
          mode="inline"
          selectedKeys={[activeKey]}
          items={panels.map((panel) => ({
            key: panel.key,
            label: panel.label,
          }))}
          onClick={({ key }) => onSelect(key)}
          style={{ borderRight: "none", background: "transparent" }}
        />
      </div>
    </div>
  );
}
